<div class="cardfile mt-2">
    <div class="row align-items-center my-3 mx-1">
      <div class="col-lg-10 col-xs-10 col-12 sm-center">
        <label class="customer-red fn-28 fw-600">{{ 'Insurance Products'}}</label>
      </div>
    </div>
    <div class="pt-2 pb-4" [hidden]="beforeLoad">
      <div class="row justify-content-center p-1">
      <div class="row col-md-8 col-sm-12">
        <!-- <button mat-mini-fab color="secondary" class="leftarrow btnred " (click)="previous()" [hidden]="showOriginalData" [disabled]="leftArrowDisabled">
          <em class="fa fa-angle-left" aria-hidden="true"></em>
        </button> -->
        @for(type of insuranceTypeCards; track type){
        <div  class="col-sm-12 col-md-4 mb-2">
    <div class="lob-image custom-card h-100"
         [ngClass]="{
           'health-bg': type.mstGroupID == LOBEnum.health,
           'motor-bg': type.mstGroupID == LOBEnum.motor,
           'life-bg': type.mstGroupID == LOBEnum.life,
           'travel-bg': type.mstGroupID == LOBEnum.travel,
           'fire-bg': type.mstGroupID == LOBEnum.fireAndLightening,
           'workmen-bg': type.mstGroupID == LOBEnum.workmen,
           'group-bg': type.mstGroupID == LOBEnum.groupPersonalAccident,
           'engineering-bg' : type.mstGroupID == LOBEnum.engineering,
           'shimmer-card': showOriginalData
         }"
         (click)="openTypeOfInsuranceCard(type)">
        <div class="card-body text-center">
            <div class="mb-2">
                <em class="fa fa-xl"
                    [ngClass]="{
                      'fa-heart-pulse': type.mstGroupID == LOBEnum.health,
                      'fa-car': type.mstGroupID == LOBEnum.motor,
                      'fa-solid fa-fire': type.mstGroupID == LOBEnum.fireAndLightening,
                      'fa-solid fa-umbrella': type.mstGroupID == LOBEnum.life,
                      'fa-solid fa-person': type.mstGroupID == LOBEnum.workmen,
                      'fa-solid fa-location-dot': type.mstGroupID == LOBEnum.travel,
                      'fa-solid fa-person-falling-burst': type.mstGroupID == LOBEnum.groupPersonalAccident,
                      'fa-solid fa-wrench' : type.mstGroupID == LOBEnum.engineering
                    }"></em>
            </div>
            <p class="fn-18">{{ type.pZLOB }}</p>
        </div>
    </div>
</div>
        }

        <!-- <button mat-mini-fab color="secondary" class="rightarrow btnred" (click)="next()" [hidden]="showOriginalData" [disabled]="rightArrowDisabled">
          <em class="fa fa-angle-right" aria-hidden="true"></em>
        </button> -->
      </div>
      <div class="col-md-4 col-sm-12" >
        <div class="" *ngIf="landingImgPath">
          <img src="../assets/images/{{landingImgPath}}" class="img-fluid" alt="">
        </div>
       
      </div>
    </div>
    </div>
  </div>
  